import React from 'react'
import { useField, useFormikContext } from 'formik'
import DatePicker from 'react-datepicker'
import './react-datepicker.css'

const getFieldCSSClasses = (touched, errors) => {
	const classes = ['form-control']
	if (touched && errors) {
		classes.push('is-invalid')
	}

	if (touched && !errors) {
		classes.push('is-valid')
	}

	return classes.join(' ')
}

export function DateTimePickerField({ ...props }) {
	const { setFieldValue, errors, touched } = useFormikContext()
	const [field] = useField(props)
	return (
		<>
			{props.label && <label>{props.label}</label>}
			<br />
			<DatePicker
				showTimeSelect
				dateFormat='Pp'
				className={getFieldCSSClasses(touched[field.name], errors[field.name])}
				{...field}
				{...props}
				selected={(field.value && new Date(field.value)) || null}
				onChange={(val) => {
					setFieldValue(field.name, val)
				}}
			/>
			{errors[field.name] && touched[field.name] ? (
				<div className='invalid-datepicker-feedback'>
					{errors[field.name].toString()}
				</div>
			) : (
				<div className='feedback'>
					Please enter <b>{props.label}</b> in 'mm/dd/yyyy' format
				</div>
			)}
		</>
	)
}
